export default [
    '$scope',
    '$routeParams',
    '$window',
    'SPBrandData',
    function BrandOrderBundleController($scope, $routeParams, $window, SPBrandData) {
        $scope.credentials = {};

        $scope.authenticateOrderBundle = function authenticateOrderBundle() {
            if (!$scope.email) {
                return;
            }

            SPBrandData.orderBundleAuth(
                $routeParams.orderId,
                $routeParams.orderDownloadId,
                $scope.email,
                $scope.credentials.doesAcceptTerms,
                function withSuccessResponse(response) {
                    if (typeof response.zipBundleData === 'object') {
                        $scope.zipBundleData = response.zipBundleData;
                    }
                },
                function withErrorResponse(response) {
                    if (typeof response.errors === 'object') {
                        $scope.errors = response.errors;
                    }
                }
            );
        };

        // Called by <bundle-file-list> from React. It tracks its own downloaded state, so there
        // is nothing to flag on the item and no digest to schedule here.
        $scope.downloadFile = function downloadFile(bundleItem) {
            SPBrandData.logOrderBundleDownloaded(
                $scope.zipBundleData.id,
                function withSuccessResponse() {
                    // Success
                },
                function withErrorResponse() {
                    // Error
                }
            );

            $window.location.href = bundleItem.url;
        };
    }
];
